export default __webpack_public_path__ + "static/media/2076_01 drawing.63b46477.gif";